import React, { useState } from 'react';
import { Modal, Button } from 'antd';
import InvQuoteList from '../../../invoice/InvQuoteList';

const LinkInvoiceModal = ({ open, onClose, onSelect }) => {
  // We'll use a callback prop (onSelect) to notify parent when an invoice is chosen
  // For now, InvQuoteList will be shown in a modal, and you can enhance InvQuoteList to accept onSelect if needed

  // Optionally, you could add pagination state here if you want to override InvQuoteList's pagination

  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      width={1000}
      destroyOnClose
      title="Select Invoice to Link"
    >
      {/* You may want to enhance InvQuoteList to accept an onSelect prop for row click */}
      <InvQuoteList onSelect={onSelect} showOnlyInvoices />
      <div style={{ textAlign: 'right', marginTop: 16 }}>
        <Button onClick={onClose}>Cancel</Button>
      </div>
    </Modal>
  );
};

export default LinkInvoiceModal;
